var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"spinner"},[_c('div',{class:[_vm.size, 'spinner-border'],attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }